export default __webpack_public_path__ + "400a93fc1e382fea70e8177abed769d6.svg";